import React, { useState, useEffect } from 'react'
import { trackBookingClick } from '../lib/tracking'

export default function StickyNav() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <nav
      className={`fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 z-50 transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-2 md:gap-4">
          {/* Quick Links */}
          <div className="flex gap-1 md:gap-3 text-xs md:text-sm overflow-x-auto">
            <button
              onClick={() => scrollToSection('pricing')}
              className="whitespace-nowrap px-2 md:px-3 py-1.5 md:py-2 text-[#2c3424] hover:text-[#768064] transition-colors font-medium"
            >
              Cijene
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="whitespace-nowrap px-2 md:px-3 py-1.5 md:py-2 text-[#2c3424] hover:text-[#768064] transition-colors font-medium"
            >
              Galerija
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="whitespace-nowrap px-2 md:px-3 py-1.5 md:py-2 text-[#2c3424] hover:text-[#768064] transition-colors font-medium"
            >
              Pitanja
            </button>
          </div>

          {/* Book Now Button */}
          <div className="button-wrapper shrink-0">
            <a
              href="https://medispahr.wixforms.com/f/7479898417246766083"
              target="_blank"
              rel="noopener noreferrer"
              data-cta="book_now"
              data-cta-location="sticky_nav"
              onClick={() => trackBookingClick('sticky_nav')}
              className="inline-block px-4 md:px-6 py-2 md:py-3 bg-[#768064] text-white text-sm md:text-base font-medium rounded-lg hover:bg-[#2c3424] transition-colors"
            >
              Rezerviraj besplatnu konzultaciju
            </a>
          </div>
        </div>
      </div>
    </nav>
  )
}
